import LOCATIONS from "@/data/locations.yml";
import ContentBlock from "@/components/newsletter/blocks/ContentBlock";

export default {
  components: { ContentBlock },
  data() {
    return {
      LOCATIONS,
    };
  },
};
